import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { Quiz } from 'src/app/models/quiz';
import { QuizQuestionAnswer } from 'src/app/models/quizQuestionAnswer';
import { ActivatedRoute } from '@angular/router';
import { QuizService } from 'src/app/services/quiz.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { QuizQuestion } from 'src/app/models/quizQuestion';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit {
  public quiz: Quiz;
  public quizId;
  public quizLoaded:boolean=false;
  public courseId;
  public previewUrl=[];
  public newFileType:string;
  public newImageB64:string;
  public qIndex:number=0;
  public env:string;

  constructor(
    private _courseService: CourseService,
    private _route: ActivatedRoute,
    private _quiz: QuizService,
    private _notify: MatSnackBar
  ) {
    this.quizId=this._route.snapshot.paramMap.get("id");
    this.courseId=this._route.snapshot.paramMap.get("courseId");
    this.env=environment.apiEndpoint;
  }

  fileProgress(evt: any, i:number) {
    this.qIndex=i;
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      if (!file.type.includes('image')) {
        this.notify('Only images can be uploaded.', 'OK');
        return;
      }
      this.newFileType=file.type;
      var reader = new FileReader();
      reader.onload =this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  private _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.quiz.questions[this.qIndex].newImageB64= btoa(binaryString);
    this.quiz.questions[this.qIndex].newImageType=this.newFileType;
    this.previewUrl[this.qIndex]='data:' + this.newFileType + ';base64, ' + this.quiz.questions[this.qIndex].newImageB64;
    this.newFileType='';
    this.newImageB64='';
    this.qIndex=0;
  }

  public resetUploader(i){
    this.previewUrl[i]='';
    this.quiz.questions[i].newImageB64='';
    this.quiz.questions[i].newImageType='';
    this.newImageB64='';
    this.newFileType='';
  }

  public addQuestion(){
    this._quiz.addQuestion(this.quiz.id).subscribe(
      (res:QuizQuestion) => {
        this.quiz.questions.push(new QuizQuestion(res));
      }
    );
  }

  public deleteQuestion(
    questionId:number,
    questionIndex:number
  ){
    if(!confirm('Confirm you want to delete this question.')) return;
    this._quiz.deleteQuestion(questionId).subscribe(
      res => {
        this.quiz.questions.splice(questionIndex, 1);
        this.notify('Question deleted.', 'OK');
      }
    );
  }

  public addAnswer(
    questionId:number,
    questionIndex:number
  ) {
    this._quiz.addAnswer(this.quiz.id, questionId).subscribe(
      res => {
        this.quiz.questions[questionIndex].answers.push(new QuizQuestionAnswer(res));
      }
    );
  }

  public deleteAnswer(
    questionIndex:number,
    answerIndex:number,
    answerId:number
  ) {
    this._quiz.deleteAnswer(answerId).subscribe(res => {
      this.quiz.questions[questionIndex].answers.splice(answerIndex,1);
    });
  }

  public saveQuiz(){
    this._quiz.saveQuiz(this.quiz).subscribe(res => {
      this.notify('Quiz updated', 'OK');
      this.getQuiz();
      this.quiz.questions.forEach((q, i)=>{
        this.resetUploader(i);
      });
    });
  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  ngOnInit() {
    this.getQuiz();
  }

  public getQuiz(){
    this._courseService.getQuiz(this.quizId).subscribe(
      res => {
        this.quiz=res;
        this.quizLoaded=true;
      }
    );
  }

}
